import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-16 bg-legal-900 border-y border-legal-700" data-id="element-93">
      <div className="container mx-auto px-4" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-legal-800 border-2 border-gold-500/30 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-95">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-gold-500/5 blur-3xl rounded-full pointer-events-none" data-id="element-96"></div>

          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-legal-900 border border-gold-500/50 mb-6 relative z-10" data-id="element-97">
            <ShieldCheck className="w-10 h-10 text-gold-500" data-id="element-98" />
          </div>

          <h2 className="text-2xl md:text-3xl font-serif font-bold text-white mb-4 relative z-10" data-id="element-99">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-slate-300 text-lg max-w-2xl mx-auto relative z-10" data-id="element-100">
            Estamos tan seguros de la calidad y utilidad de este material que te
            ofrecemos una garantía total. Si dentro de los primeros 7 días
            considerás que el tratado no aporta valor a tu ejercicio
            profesional, te devolvemos el 100% de tu dinero. Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
};